export default function () {
    function get(name: string): string | null {
        const meta: HTMLMetaElement | null = document.querySelector(
            `meta[name='${name}']`,
        )
        const content = meta?.content

        if (typeof content !== 'string') {
            return null
        }

        return content
    }

    function getBookingFormThemeMainBackgroundColor(): string {
        const bookingFormThemeMainBackgroundColor = get(
            'bookingFormThemeMainBackgroundColor',
        )

        if (typeof bookingFormThemeMainBackgroundColor !== 'string') {
            throw new Error(
                '"bookingFormThemeMainBackgroundColor" meta tag is undefined.',
            )
        }

        return bookingFormThemeMainBackgroundColor
    }

    function getIsGoogleAnalyticsTagPresent(): boolean {
        const isGoogleAnalyticsTagPresent = get('isGoogleAnalyticsTagPresent')

        if (
            isGoogleAnalyticsTagPresent !== '0' &&
            isGoogleAnalyticsTagPresent !== '1'
        ) {
            throw new Error(
                '"isGoogleAnalyticsTagPresent" meta tag is undefined.',
            )
        }

        return isGoogleAnalyticsTagPresent === '1'
    }

    function getIsMetaPixelIdPresent(): boolean {
        const isMetaPixelIdPresent = get('isMetaPixelIdPresent')

        if (isMetaPixelIdPresent !== '0' && isMetaPixelIdPresent !== '1') {
            throw new Error('"isMetaPixelIdPresent" meta tag is undefined.')
        }

        return isMetaPixelIdPresent === '1'
    }

    return {
        getBookingFormThemeMainBackgroundColor,
        getIsGoogleAnalyticsTagPresent,
        getIsMetaPixelIdPresent,
    }
}
